module.exports = __webpack_public_path__ + "img/New_DeliveryB2B__Cinza_Vertical.18be7fd9.png";